var _a;
import { SportDataGatewayQueryInfo, EventsBySportIdRequest } from "sb-bff-integration";
import { MarketTypeRequest } from "sbtech-online-sportcontent-sportbook";
import { TimeRange } from "sbtech-sports-data-api-client";
/*tslint:disable:no-non-null-assertion */
export var queryBuilder = {
    eventStateMap: (_a = {},
        _a[EventsBySportIdRequest.EventStateEnum.Live] = "isLive eq true",
        _a[EventsBySportIdRequest.EventStateEnum.PreLive] = "isLive eq false",
        _a[EventsBySportIdRequest.EventStateEnum.Mixed] = "",
        _a),
    buildQueryTopLeagues: function (queryParams) {
        var filters = [
            this.buildLiveFilter(queryParams.request),
            this.buildEventType(queryParams.request),
            this.buildSportsFilter(queryParams),
            this.buildEventTagsFilter(queryParams.request)
        ].filter(function (x) { return x !== ""; });
        var queryInfo = new SportDataGatewayQueryInfo("$filter=" + filters.join(" and "), queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        this.buildDateRangeFilter(queryParams.request, queryInfo);
        return queryInfo;
    },
    buildLiveFilter: function (request) {
        return this.eventStateMap[request.eventState || EventsBySportIdRequest.EventStateEnum.Mixed];
    },
    buildEventType: function (request) {
        return (request.eventTypes && request.eventTypes.length && "type in (" + request.eventTypes.map(function (type) { return "'" + type + "'"; }).join(",") + ")") || "";
    },
    buildSportsFilter: function (queryParams) {
        var sportIds = queryParams.request.ids;
        return sportIds.length ? "sportId in (" + sportIds.map(function (x) { return "'" + x + "'"; }).join(",") + ")" : "";
    },
    buildEventTagsFilter: function (request) {
        return request.eventTags && request.eventTags.length
            ? "Tags/any(tag: tag in (" + request.eventTags.map(function (tag) { return "'" + tag + "'"; }).join(",") + "))" : "";
    },
    buildMarketsQuery: function (queryParams) {
        var marketsQueries = [];
        queryParams.request.marketTypeRequests.forEach(function (marketTypeRequest) {
            var marketTypes = "marketType/id in (" + marketTypeRequest.marketTypeIds.map(function (m) { return "'" + m + "'"; }).join(",") + ")";
            if (marketTypeRequest.sportIds.length) {
                var sportIds = "sportId in (" + marketTypeRequest.sportIds.map(function (id) { return "'" + id + "'"; }).join(",") + ")";
                marketsQueries.push(marketTypeRequest.statement === MarketTypeRequest.StatementEnum.Include
                    ? "(" + marketTypes + " and " + sportIds + ")"
                    : "(" + marketTypes + " and not(" + sportIds + "))");
            }
            else {
                marketsQueries.push("(" + marketTypes + ")");
            }
        });
        return "$filter=" + marketsQueries.join(" or ");
    },
    buildDateRangeFilter: function (request, queryInfo) {
        if (request.dateRange) {
            queryInfo.from = request.dateRange.from.toISOString();
            queryInfo.timeRange = TimeRange[request.dateRange.timeRange];
        }
    },
    buildQueryByRegionId: function (queryParams) {
        var filter = this.buildRegionIdFilter(queryParams.request.regionId);
        var queryInfo = new SportDataGatewayQueryInfo("$filter=" + filter, queryParams.messageHandler);
        return queryInfo;
    },
    buildRegionIdFilter: function (regionId) {
        return "regionId eq '" + regionId + "'";
    },
    buildQueryByEventIds: function (queryParams) {
        var filter = this.buildEventIdsFilter(queryParams.request.ids);
        var queryInfo = new SportDataGatewayQueryInfo("$filter=" + filter, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        return queryInfo;
    },
    buildEventIdsFilter: function (eventIds) {
        return "id in (" + eventIds.map(function (id) { return "'" + id + "'"; }).join(",") + ")";
    },
    buildQueryByLeagueIds: function (queryParams) {
        var filter = this.buildLeagueIdsFilter(queryParams.request.ids);
        var queryInfo = new SportDataGatewayQueryInfo("$filter=" + filter, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        return queryInfo;
    },
    buildLeagueIdsFilter: function (leagueIds) {
        return "leagueId in (" + leagueIds.map(function (id) { return "'" + id + "'"; }).join(",") + ")";
    }
};
//# sourceMappingURL=queryBuilder.js.map